export default class StyleFormatter {
    static booleanProperty(bool: boolean): string {
        return bool ? '<span class="material-icons true">done</span>' :
            '<span class="material-icons false">close</span>';
    }
}
